import React from "react";
import "./AIPodcastSection.css";
import {
  Github,
  Youtube,
  FileText,
  BookOpen,
  Library,
  Podcast,
  FileCode,
  Newspaper,
  Sparkles,
} from "lucide-react";

export default function AIPodcastSection() {
  const cards = [
    {
      icon: <Github size={22} />,
      title: "Code Repositories",
      desc: "GitHub repos, README files, code examples",
      color: "icon-github",
    },
    {
      icon: <Youtube size={22} />,
      title: "YouTube Videos",
      desc: "Video transcripts with timestamps",
      color: "icon-youtube",
    },
    {
      icon: <FileText size={22} />,
      title: "Research Papers",
      desc: "arXiv, academic papers, studies",
      color: "icon-research",
    },
    {
      icon: <BookOpen size={22} />,
      title: "Documentation",
      desc: "Official docs, API references",
      color: "icon-docs",
    },
    {
      icon: <Library size={22} />,
      title: "Wiki & Knowledge Bases",
      desc: "Confluence, Notion, Wikipedia",
      color: "icon-wiki",
    },
    {
      icon: <Podcast size={22} />,
      title: "Conference Talks",
      desc: "Tech talks, presentations, keynotes",
      color: "icon-talks",
    },
    {
      icon: <FileCode size={22} />,
      title: "Technical Blogs",
      desc: "Dev.to, engineering blogs, tutorials",
      color: "icon-blogs",
    },
    {
      icon: <Newspaper size={22} />,
      title: "News & Articles",
      desc: "Latest tech news, industry updates",
      color: "icon-news",
    },
  ];

  const handleStartPodcast = () => {
    window.open("https://podcaststudio.nxnearby.com/", "_blank");
  };

  return (
    <section className="ai-podcast-section">
      <div className="ai-inner">
        <div className="ai-header">
          <div className="ai-pill"><Sparkles size={16} className="ai-pill-sparkles" /> <span>Any Content Source</span></div>

          <h2 className="ai-title">
            Turn <span>Any Content</span> Into a Podcast
          </h2>

          <p className="ai-sub">
            Our AI aggregates knowledge from multiple sources to create
            comprehensive, engaging podcasts. No more reading endless docs —
            just listen and learn.
          </p>
        </div>

        <div className="ai-card-grid">
          {cards.map((card, i) => (
            <div key={i} className="ai-card">
              <div className={`ai-card-icon ${card.color}`}>{card.icon}</div>
              <h4>{card.title}</h4>
              <p>{card.desc}</p>
            </div>
          ))}
        </div>

        <div className="ai-cta-wrapper">
          <button className="ai-start-btn" onClick={handleStartPodcast}>
            <span className="btn-ico">
              <Sparkles size={20} />
            </span>
            Start Podcast
            <span className="btn-arrow" aria-hidden="true">
              <img src="/Image/Hero/right-arrow.svg" alt="" />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
